import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerOrdiniAFornitoreModalComponent} from './worker-ordini-da-cliente-modal';

export const WorkerOrdiniAFornitoreModalModule: string = ng
    .module('worker-ordini_a_fornitore-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerOrdiniAFornitoreModalComponent', WorkerOrdiniAFornitoreModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-ordini-a-fornitore-modal/worker-ordini-a-fornitore-modal.module.ts